import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TProductSeriesDetailTestimonialAsset,
  TProductSeriesDetailTestimonialButton,
  TProductSeriesDetailTestimonialFields,
  TProductSeriesDetailTestimonialProps,
  TProductSeriesDetailTestimoniaMediaData,
} from '../types/productSeriesDetailTestimonial.types';
import { StringField } from '../../../types/types';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';

export class ProductSeriesDetailTestimonialModel {
  private readonly fields: TProductSeriesDetailTestimonialFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TProductSeriesDetailTestimonialProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get description(): StringField {
    return { value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description) };
  }

  get button1(): TProductSeriesDetailTestimonialButton {
    return this.fields?.apiData?.button1;
  }

  get button1Link(): string | undefined {
    return appendRootToInternalLink(this.button1.url);
  }

  get button2(): TProductSeriesDetailTestimonialButton {
    return this.fields?.apiData?.button2;
  }

  get button2Link(): string | undefined {
    return appendRootToInternalLink(this.button2.url);
  }

  get assets(): TProductSeriesDetailTestimonialAsset[] {
    return this.fields?.apiData?.assets || [];
  }

  get thumbnail(): string {
    return this.fields?.apiData?.assets?.[0]?.thumbnail;
  }

  get bigThumbnail(): string {
    return this.fields?.apiData?.assets?.[0]?.bigthumbnail;
  }

  get full(): string {
    return this.fields?.apiData?.assets?.[0]?.full;
  }

  get mediaTitle(): string | undefined {
    return this.fields?.apiData?.assets?.[0]?.title;
  }

  get alt(): string {
    return this.fields?.apiData?.assets?.[0]?.alt;
  }

  get mediaData(): TProductSeriesDetailTestimoniaMediaData {
    let link, type, isInternal;
    const firstAsset = this.fields?.apiData?.assets?.[0];
    if (firstAsset && (firstAsset?.role === 'video' || firstAsset?.role === 'extvideo')) {
      link = firstAsset.full?.replace('sitecore/media-library', '-/media');
      isInternal = firstAsset.role == 'video';
      type = firstAsset.role;
    } else {
      type = 'image';
    }
    return { link, type, isInternal };
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get asset() {
    return this?.assets?.length ? this?.assets?.[0] : null;
  }
}
